<template>
    <div class="container">
        <b-modal
            :model-value="showDialogCreate"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-rol-dialog"
            @hide="closeModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <h5 class="form-label">{{ labels.name }}</h5>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="nombre" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre del rol"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <h5 class="form-label">{{ labels.description }}</h5>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-textarea 
                            v-model="descripcion" 
                            rows="3" 
                            max-rows="6" 
                            class="form-input"
                            placeholder="Descripción del rol"
                        ></b-form-textarea>
                    </b-col>
                </b-row>

                <!-- NUEVO CAMPO: Límite de sesiones -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <h5 class="form-label">{{ labels.limiteSesiones }}</h5>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model.number="limiteSesiones" 
                            type="number" 
                            min="1" 
                            step="1"
                            class="form-input"
                            placeholder=" "
                            @keypress="soloNumeros"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.cerrar }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardaInfoRol()">{{ labels.guardar }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Roles from '../../services/Roles'; 

export default {
    name: 'Create',
    props: ['showDialogCreate'],
    data: () => ({
        nombre: "",
        descripcion: "",
        limiteSesiones: null, // vacío por defecto
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: 'Crear Rol',
                    name: "Nombre",
                    description: "Descripción",
                    limiteSesiones: "Límite de sesiones simultáneas",
                    guardar: 'Guardar',
                    cerrar: 'Cerrar',
                    infoTitle: 'Datos del rol',
                    infoText: 'Completa la información y guarda el nuevo rol.'
                }
            } else {
                return {
                    title: 'Create Role',
                    name: "Name",
                    description: "Description",
                    limiteSesiones: "Simultaneous session limit",
                    guardar: 'Save',
                    cerrar: 'Close',
                    infoTitle: 'Role information',
                    infoText: 'Complete the information and save the new role.'
                }
            }
        }
    },
    methods: {
        soloNumeros(evt) {
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
        },
        closeModal() {
            this.$emit('closeModal', false) 
        },
        async guardaInfoRol() {
            if (this.nombre == "") { 
                this.$toast.error('Diligenciar el nombre')
                return
            } 
            if (this.descripcion == "") { 
                this.$toast.error('Diligenciar la descripción')
                return
            } 
            if (this.limiteSesiones === null || this.limiteSesiones === "" || this.limiteSesiones < 1) {
                this.$toast.error('El límite de sesiones debe ser al menos 1')
                return
            }

            let infoForm = {
                'nombre': this.nombre, 
                'descripcion': this.descripcion, 
                'idUser': this.$store.state.userId 
            }

            try {
                const res = await Roles.createRol(infoForm);
                if (res.status == 201) {
                    const rolId = res.data.rolId;

                    if (rolId) {
                        await Roles.updateLimiteSesiones({
                            rol_id: rolId,
                            limite_sesiones: this.limiteSesiones,
                            idUser: this.$store.state.userId
                        });
                    }

                    this.$toast.success('Rol creado correctamente')
                    this.$emit('created')
                    this.closeModal()
                    this.nombre = ""
                    this.descripcion = ""
                    this.limiteSesiones = null
                }
            } catch (error) {
                console.log(error)
                this.$toast.error('No se pudo crear el rol')
            }
        }
    }
}
</script>